// Vendor libraries
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class ImageModule {
}
ImageModule.ɵfac = function ImageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageModule)(); };
ImageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ImageModule });
ImageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
